export const HINT_ZINDEX = 300;
export const DROPDOWN_ZINDEX = 1000;
export const DROPDOWN_WRAP_ZINDEX = 1010;
export const STREET_VIEW_ZINDEX = 100;
export const HEADER_ZINDEX = 200;
export const MODAL_ZINDEX = 1500;
